import React, { useEffect, useState, useRef } from "react";
import { useNavigate, useParams } from "react-router-dom";

interface OnboardingAndDeliveryScheduleProps {
  isOpen: boolean;
  customerId: string;
  onClose: () => void;
}

const OnboardingAndDeliveryScheduleStart = ({
  isOpen,
  onClose,
  customerId,
}: OnboardingAndDeliveryScheduleProps) => {
  const [isLoadingIframe, setIsLoadingIframe] = useState(true);
  const [isCamDeliveryOpen, setIsCamDeliveryOpen] = useState(false);
  const [showTransitionLoader, setShowTransitionLoader] = useState(false);

  const navigate = useNavigate();
  const url = useParams();
  

  useEffect(() => {
    const handleEsc = (e: KeyboardEvent) => {
      if (e.key === "Escape") {
        onClose();
        navigate(`/customerDashboard/${customerId}`);
      };
    };

    if (isOpen) {
      window.addEventListener("keydown", handleEsc);
      setIsLoadingIframe(true);
    }

    return () => window.removeEventListener("keydown", handleEsc);
  }, [isOpen, onClose]);

  const handleIframeLoad = () => {
    setIsLoadingIframe(false);
  };

  const handleContinue = () => {
    setShowTransitionLoader(true);
    setTimeout(() => {
      setShowTransitionLoader(false);
      setIsCamDeliveryOpen(true);
    }, 400);
  };

  const previusStep = () => {
  setIsCamDeliveryOpen(false);
  setShowTransitionLoader(true);
  setTimeout(() => {
    setShowTransitionLoader(false);
  }, 400);
};

  if (!isOpen) return null;

  return (
    <div
      className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50 overflow-y-auto"
      onClick={(e) => e.target === e.currentTarget && onClose()}
    >
      <div className="relative bg-white rounded-lg w-full max-w-4xl max-h-[90vh] flex flex-col overflow-hidden transition-all duration-300">
        <button
          onClick={() => {
            onClose(); 
            navigate(`/customerDashboard/${customerId}`); 
          }}
          className="absolute right-4 top-2 text-gray-400 hover:text-gray-500 z-20"
        >
          <svg
            className="w-6 h-6"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="M6 18L18 6M6 6l12 12"
            />
          </svg>
        </button>

        <div className="p-4 flex-grow overflow-y-auto relative" style={{ minHeight: "550px" }}>
          {(isLoadingIframe || showTransitionLoader) && (
            <div className="absolute inset-0 flex items-center justify-center bg-white bg-opacity-80 z-10 rounded-lg">
              <div className="animate-spin rounded-full h-10 w-10 border-t-4 border-blue-500 border-solid"></div>
            </div>
          )}

          {!isCamDeliveryOpen && (
            <div className="w-full">
              <iframe
                src="https://apiup.lisual.com/widget/booking/p46bNoYdzOQOZfX9NFQ2" 
                className="w-full h-[500px] sm:h-[400px] md:h-[500px] lg:h-[550px]"
                style={{ border: "none" }}
                title="FunnelUp Booking Widget"
                allow="clipboard-write; fullscreen"
                onLoad={handleIframeLoad}
              />
            </div>
          )}

          {isCamDeliveryOpen && (
            <div className="w-full h-full">
              <iframe
                src="https://docs.google.com/forms/d/e/1FAIpQLSd91CGMymg9TzoOJHS6T1OGmhhRlot77Z5un_JMzP5-Rzvucw/viewform?embedded=true"
                className="w-full h-[500px] sm:h-[400px] md:h-[500px] lg:h-[550px]"
                style={{ border: "none" }}
                title="CamDelivery Form"
                allow="clipboard-write; fullscreen"
                onLoad={() => setShowTransitionLoader(false)}
              />
            </div>
          )}
        </div>

        <div className="px-6 py-4 border-t flex justify-end">
          {!isCamDeliveryOpen && (
            <>
              {/*<button
                onClick={onClose}
                className="px-4 py-2 bg-gray-300 rounded hover:bg-gray-400 mr-4"
              >
                Cancelar
              </button>*/}
              <button
                onClick={handleContinue}
                className="px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600"
              >
                Ir al siguiente paso
              </button>
            </>
          )}

          {isCamDeliveryOpen && (
            <>
            <button
                onClick={previusStep}
                className="px-4 py-2 bg-gray-300 rounded hover:bg-gray-400 mr-4"
              >
                Volver al paso anterior
              </button>
            <button
              onClick={() => {
                onClose();
                navigate(`/customerDashboard/${url.customerId}`);
              }}
              className="px-4 py-2 bg-green-300 rounded hover:bg-green-400"
            >
              Finalizar
            </button>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default OnboardingAndDeliveryScheduleStart;
